import { Component, Input, OnChanges, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PaymentService } from './payment.service';
import { CommonConstants } from './../common/utilities/commonConstants';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { Formatter } from '../common/services/formatter';
import { PaymentStatusService } from './../paymentReview/paymentStatus.service';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { environment } from 'src/environments/environment';
import { ProductReviewService } from '../productReview/productReview.service';
import { SharedService } from '../common/services/sharedService';
import { DrawerComponent } from '../common/utilities/drawer/drawer.component';
import { FormValidator } from '../common/services/formValidator.service';
import { PersonalDetailsCall } from '../common/services/personalDetails.service';
import { startWith, pairwise } from 'rxjs/operators';
import { EmitterService } from '../common/services/emitter.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { PlanDetailsService } from '../common/services/planDetails.service';
import { AnalyticsService } from '../common/services/device.analytics.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
declare const CreatePayment: any;

declare var Razorpay: any;
@Component({
  selector: 'app-payment-link',
  templateUrl: './payment.template.html',
  styleUrls: ['./payment.style.scss'],
  providers: [PaymentService, PaymentStatusService]
})
export class PaymentComponent implements OnChanges, OnInit {
  public PaymentResponse: Model.PaymentObject;
  private PaymentDetailObj: { payload: { applicationId: any; quoteId: any } }; // payNowFlag: boolean;
  @Input() public PaymentObject: Model.PaymentObject;
  @Input() public ButtonName: string;
  @Input() public IsValid: boolean;
  @Input() public SaveDataObj;
  @Input() public PaymentFailObject: Model.PaymentClosedPayload;
  @Input() public BaseFlag: any;
  @Input() public emiFlag: boolean;
  @Input() public paymentMode: any;
  @Input() public errorCode: number;
  @Input() public paymentStatus: any;
  @Input() public disableFlag;
  @Input() public payLaterFLow;
  @Input() public SummaryData;
  @Input() public isPaymentFailed;
  @Input() public ClpData: Model.ClpData;
  public Amount: number;
  // Private Variables
  private _paymentObject;
  private _orderId: string;
  private _bagicRefNum: string;
  private _mobileNumber: string;
  private _emailId: string;
  public PaymentClosed: boolean;
  public PaymentIdReceived = false;
  public MainLoadingText = 'Stay with us. We\'re almost done...';
  public RazorPayKey: string;
  public ShowPaymentLoader = false;
  public notEligible: boolean;
  public showLoader = false;
  public systemPaymentId: any;
  public pinCode;
  public serviceMessage: any;
  public quoteItemDetail: any;
  public lat: any = '';
  public lng: any = '';
  public latlong: any = '';
  public proposerName: string;
  showButtonLoader: boolean;
  newOtpshowLoader: boolean;
  initiateError: string;
  quoteDetail;
  appQuoteCriteriaId: any;
  showOtpDrawer = false;
  public healthOtpForm: FormGroup;

  public resendOTPCount: number = 0;
  public IsOTPResend = false;
  alreadyRunningTimer: any;
  otpResponse: ActivitiModel.MTResponse<any>;
  addressDetail: any;
  address: any;
  isTimerStarted: boolean;
  public ServiceError: string;
  timerOn: boolean;
  timer;
  remainingTime: string = "01:00";
  otpFieldtimer;
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  public aemFragmentInfo: any;
  bflJourney: any;
  triggerCount: number;
  ServiceErrorCode: any;
  isOtpPasted: boolean = false;
  private _proposerName: any;
  isOtpFormValid: boolean;

  // Constructor
  constructor(
    public FormValidators: FormValidator,
    private _formBuilder: FormBuilder,
    public formatter: Formatter,
    public sharedService: SharedService,
    private _paymentService: PaymentService,
    private _routerService: RouteHandlerService,
    private paymentStatusService: PaymentStatusService,
    private _sessionStorage: SessionHandlerService,
    private _productReviewService: ProductReviewService,
    private _personalDetailsCall: PersonalDetailsCall,
    private _emitterService: EmitterService,
    private _adobe_analytics_service: adobe_analytics_service,
    private _planDetailsService: PlanDetailsService,
    private analyticsService: AnalyticsService,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandelerService: CookieHandlerService
  ) { }
  // On Component Init
  public ngOnChanges() {
    this.getContentFragment();
    this.addPaymentScript();
    this.setValues();
    this.getSummaryDetails();

  }
  public ngOnInit() {
    this.bflJourney = this.sharedService.isBFLJourney();
    this.getContentFragment();
    this.getUserLocation();
    const fetchPaymentData = {
      applicationId: JSON.parse(this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId)),
      quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
    };
    if (this._sessionStorage.GetSession('status') == 'expired') {
      this.payHorizontal();
    }
    if (this.ButtonName !== 'RETRY PAYMENT') {
      this.fetchPaymentStatus(fetchPaymentData);
    }
    this.buildHealthOtpForm();
    this.getAddressDetails();
  }
  public getContentFragment() {
    this._planDetailsService.getAemDetails().subscribe((res) => {
      this.aemFragmentInfo = res.properties.elements;
    });
  }

  public buildHealthOtpForm() {
    this.healthOtpForm = this._formBuilder.group({
      digit1: ['', Validators.compose([Validators.required])],
      digit2: ['', Validators.compose([Validators.required])],
      digit3: ['', Validators.compose([Validators.required])],
      digit4: ['', Validators.compose([Validators.required])],
      digit5: ['', Validators.compose([Validators.required])],
      digit6: ['', Validators.compose([Validators.required])],
    });

    this.healthOtpForm.valueChanges.pipe(startWith(undefined), pairwise())
      .subscribe(valuesArray => {
        if (this.healthOtpForm.valid) {
          this.isOtpFormValid = true;
        } else {
          this.isOtpFormValid = false;
        }
      });

  }

  public PayByRazorPay(retryAction?: string) {
    this.PaymentDetailObj = {
      payload: {

        applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
        quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
      }
    };
    this.PaymentIdReceived = true;
    this.getPaymentDetails(retryAction);
  }
  // Setting Payment Input Object
  private setValues() {
    this.PaymentResponse = this.PaymentObject !== undefined ? this.PaymentObject : this.PaymentFailObject;
    if (this.PaymentResponse) {
      this.Amount = this.PaymentResponse.amount;
      this._mobileNumber = this.PaymentResponse.mobileNumber;
      this._emailId = this.PaymentResponse.emailId;
    } else {
      console.error('ERROR:: No payment object received.');
    }
  }

  private addPaymentScript() {
    // attach adobe script to head tag
    const script = document.createElement('script');
    script.setAttribute('src', environment['paymentScript']);
    script.setAttribute('type', 'text/javascript');
    document.head.appendChild(script);
    console.log('script added..');
  }

  public openPaymentOtpDrawer() {
    if (this.ClpData.isClpJourney) {
      this.onDateRangeCheck().then(() => {
        this.remainingTime = '01:00';
        this.healthOtpForm.reset();
        this.generateOTP('paymentOtpDrawer');
      }).catch(() => {
        this.drawer.filter((item) => {
          return ('nonstp' === item.drawerId);
        })[0].open();
      });
    } else {
      this.remainingTime = '01:00';
      this.healthOtpForm.reset();
      this.generateOTP('paymentOtpDrawer');
    }
  }

  public openDrawer(itemId) {
    this.drawer.filter((item) => {
      return (itemId === item.drawerId);
    })[0].open();
  }
  public backFromOTP() {
    this.showOtpDrawer = false;
  }
  private getAddressDetails() {
    const data = {
      applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
      quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
      addressCode: CommonConstants.CookieKeys.addressCode
    };
    this._personalDetailsCall.GetAddressDetails(data).subscribe((resp: ActivitiModel.MTResponse<any>) => {
      if (!resp.errors) {
        if (resp.payload) {
          this.address = (resp.payload.address1 ? resp.payload.address1 : '') + ' ' +
            (resp.payload.address2 ? resp.payload.address2 : '') + ' ' + (resp.payload.address3 ? resp.payload.address3 : '');
          this.addressDetail = resp.payload;
        }
      }
    }, () => {
      this.showLoader = false;
    });
  }
  public generateOTP(itemId): void {
    this.showLoader = true;
    this.ServiceError = null;
    this.ServiceErrorCode = null;
    this._productReviewService.postSendMobileOTPForReviewDetails(this.createPayloadForGenrateOtp()).subscribe(
      (response: any) => {
        if (response.nextTask && response.nextTask.nextTaskKey === CommonConstants.Routes.Application.quoteConsentOtp) {
          this.isTimerStarted = true;
          this.openDrawer(itemId);
          this.resendOTPCount = 0;
          this.triggerCount = 0;
          this.otpCountDown(60);
          this.otpResponse = response;
          document.getElementById('digit1').focus();
        } else if (response.nextTask && response.nextTask.nextTaskKey === CommonConstants.Routes.Application.paymentInitiate) {
          this.payHorizontal();
        }
        else if (response.nextTask && response.nextTask.nextTaskKey) {
          this._routerService.RouteToNextTask(response.nextTask.nextTaskKey);
        } else if (response.errorBean && CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {

          this.drawer.filter((item) => {
            return (itemId === item.drawerId);
          })[0].open();
          this.ServiceError = response.errorBean[0].errorMessage;
          this.ServiceErrorCode = response.errorBean[0].errorCode;
        } else if (response && response.error) {

          this.drawer.filter((item) => {
            return (itemId === item.drawerId);
          })[0].open();
          this.ServiceError = "Something went wrong";
        }
        this.showLoader = false;
        this.positionCTCIcon('150px');
      },
      (error: any) => {

        this.showLoader = false;
        if (error.status === 440) {
          this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).emit(true);
        }
        if (error) {
          this.ServiceError = "Something went wrong";
          this.drawer.filter((item) => {
            return (itemId === item.drawerId);
          })[0].open();
        }
        this.positionCTCIcon('150px');
      }
    );
  }
  // Creating Payment Object
  private createPaymentObject(retryAction) {
    this._paymentObject = {
      key: this.RazorPayKey,
      amount: (this.Amount * 100), // 2000 paise = INR 20
      name: 'Bajaj Finserv Direct Ltd',
      description: 'Insurance Premium',
      image: null,
      handler: (response) => {
        console.log(response);
        const payload: Model.PaymentOutputPayload = {
          orderId: this._orderId,
          paymentId: response.razorpay_payment_id,
          applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
          systemPaymentId: this.systemPaymentId,
          quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
        };
        this.PaymentIdReceived = false;
        this.razorPayPostCall(payload, 'razorPay', retryAction);
      },
      prefill: {
        contact: this._mobileNumber,
        email: this._emailId
      },
      notes: {
        REQUESTID: this._bagicRefNum,
      },
      modal: {
        escape: false,
        ondismiss: () => {
          const payload: Model.PaymentObject = {
            orderId: this._orderId,
            quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
            paymentId: null,
            applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
            systemPaymentId: this.systemPaymentId
          };
          this.PaymentClosed = true;
          this.razorPayPostCall(payload, 'razorPayClosed', retryAction);
        }
      },
      order_id: this._orderId,
      theme: {
        color: '#034263'
      }
    };
  }
  private getPaymentDetails(retryAction) {
    const paymentObject = this.PaymentObject !== undefined ? this.PaymentObject : this.PaymentFailObject;
    const appId = paymentObject.applicationId ? paymentObject.applicationId.toString() :
      this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId);
    const data = this.PaymentDetailObj;
    if (appId) {
      this._paymentService.GetPaymentDetails(appId, data).subscribe((mtResponse: ActivitiModel.MTResponse<Model.PaymentDetails>) => {
        if (!mtResponse.errorBean) {
          this._orderId = mtResponse.payload.orderId;
          this._bagicRefNum = mtResponse.payload.referenceNumber;
          this.RazorPayKey = mtResponse.payload.apiKey;
          this.systemPaymentId = mtResponse.payload.systempaymentid;
          this.createPaymentObject(retryAction);
          const razorPayObj = new Razorpay(this._paymentObject);
          razorPayObj.open();
        } else {
          setInterval(() => {
            this.PaymentIdReceived = false;
          }, 1000);
          if (mtResponse.error) {
            mtResponse.error.forEach(element => {
              if (element.errorCode === 'PDM-842') {
                this.serviceMessage = element.errorMessage;
              }
              if (element.errorCode === 'PDM-844') {
                this.serviceMessage = element.errorMessage;
              }
              if (element.errorCode === 'BFSD-440') {
                this.serviceMessage = 'Your session has been expired. Please try with another session.';
              }
              if (element.errorCode === 'QDM-472') {
                this.serviceMessage = element.errorMessage;
              } else {
                this.serviceMessage = 'Something went wrong. Please try again later';
              }
            });
          }
        }
      }, (error: any) => {
        console.log(error);
        if (error.status === 440) {
          this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).emit(true);
        }
      });
    } else {
      console.error('ERROR::Unable to find application Id.');
    }
  }
  private razorPayPostCall(requestData: Model.PaymentOutputPayload, paymentFlag, retryAction) {
    this.PaymentIdReceived = true;
    let paymentType;
    if (paymentFlag === 'razorPay') {
      paymentType = 'postprocessingPayment';
    } else {
      paymentType = 'cancelPayment';
    }
    const personQuoteId = {
      personCode: CommonConstants.PersonCodes.Proposer,
      quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
    };
    this._paymentService.PostCallRazorPayment(requestData, paymentType, personQuoteId, retryAction)
      .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
        this.showLoader = false;
        if (!mtResponse.errorBean) {
          if (retryAction === 'retryRazorPay') {
            if ((mtResponse.nextTaskKey === 'insHurrayPage') || (mtResponse.nextTaskKey === 'insPolicyPage')) {
              this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTaskKey);
            }
            this._routerService.RouteToNextTask(mtResponse.nextTaskKey, null, null, true);
          } else {
            if ((mtResponse.nextTask.nextTaskKey === 'insHurrayPage') || (mtResponse.nextTask.nextTaskKey === 'insPolicyPage')) {
              this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTask.nextTaskKey);
            }
            this._routerService.RouteToNextTask(mtResponse.nextTask.nextTaskKey, null, null, true);
          }
        } else {
          this.PaymentIdReceived = false;
        }
      },
        () => {
          this.showLoader = false;
          this.PaymentIdReceived = false;
        });
  }


  private fetchPaymentStatus(fetchPaymentData: any) {

    this.showLoader = true;
    console.log('PaymentIdReceived-', this.PaymentIdReceived);
    this.paymentStatusService
      .FetchPaymentStatus(fetchPaymentData)
      .subscribe((resp: Model.MTResponse<any>) => {
        const mtPaymentStatusResponse: Model.MTResponse<any> = resp;
        const paymentRespclone: any = resp;
        if (!(paymentRespclone.error == 200)) {
          this.payLaterFLow = true;
        } else {
          this.payLaterFLow = false
        }
        if (mtPaymentStatusResponse.payload !== null) {
          if (!resp.payload) {
            this.showLoader = false;
            return;
          }
          const paymentStatusResp = resp.payload.paymentStatusResponse;
          this.Amount = paymentStatusResp.paymentAmount;
          this.paymentMode = paymentStatusResp.paymentMode;
          this.paymentStatus = paymentStatusResp.paymentStatus;
          this.systemPaymentId = paymentStatusResp.systemPaymentId;
          this._emailId = resp.payload.emailId;
          this._mobileNumber = resp.payload.mobileNo;
          this.pinCode = resp.payload.pinCode;
          if (paymentStatusResp.paymentStatus === 'Success') {
            const inputRequestData = {
              applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
              quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
              personCode: CommonConstants.PersonCodes.Proposer
            };
            this._paymentService.paymentStatusSuccessCall(inputRequestData)
              .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                if (!mtResponse.errorBean) {
                  let nextTaskKey = "";
                  if (mtResponse.nextTaskKey) {
                    nextTaskKey = mtResponse.nextTaskKey;
                  } else if (mtResponse.nextTask.nextTaskKey) {
                    nextTaskKey = mtResponse.nextTask.nextTaskKey;
                  }
                  if (nextTaskKey === 'insHurrayPage') {
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, nextTaskKey);
                  }
                  this._routerService.RouteToNextTask(nextTaskKey, null, null, true);
                } else {
                  this.showLoader = false;
                }
              });
          } else {
            this.showLoader = false;
          }
        } else {
          console.log(resp)
          this.showLoader = false;
        }
      },
        (error: any) => {
          console.log(error)
          this.showLoader = false;
        });
  }

  // Set the subsections for payment payload
  public paymentSubsectionDetails() {
    let subsectionArray: any = [];
    this.quoteItemDetail.forEach(pricing => {
      subsectionArray.push(
        { key: 'Coverage', value: 'Rs. ' + this.formatter.ConvertNumberToAmount(pricing.sumassuredamt.toString()) },
        { key: 'Premium', value: 'Rs. ' + this.formatter.ToCurrency(pricing.grossPremiumAmount.toString()) },
        { key: 'Tenure', value: pricing.tenure === 1 ? pricing.tenure + ' Year' : pricing.tenure + ' Years' }
      );
    });
    return subsectionArray;
  }
  createOrderIdPayload() {
    let payload;
    if (this.PaymentResponse) {
      payload = {
        'payload': {
          "applicationId": this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
          "quoteId": this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
          "name": this.proposerName ? this.proposerName : null,
          "mobile": this.PaymentResponse.mobileNumber,
          "email": this.PaymentResponse.emailId
        }
      }
    } else {
      payload = {
        'payload': {
          'applicationId': this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
          'email': this._emailId,
          'mobile': this._mobileNumber.toString(),
          'name': this._proposerName,
          'quoteId': this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
        }
      };
    }
    return payload;
  }

  payHorizontal() {
    this.showButtonLoader = true;
    const payload = this.createOrderIdPayload();
    this._paymentService.saveCustomerJourneyData(payload).subscribe((response) => {
      this.showButtonLoader = true;
      this.initiateError = null;

      if (!response.error && response.payload && response.payload.orderId) {
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.orderId, response.payload.orderId);
        let utmSource = this._routerService.UtmStamping().utmSource ? this._routerService.UtmStamping().utmSource : '';
        let upiOptions = response.payload['upi'] || null;
        let requestPayload = {
          'orderId': response.payload.orderId,
          'successURL': environment.serviceBaseUrls.PaymentSuccessURL,
          // 'successURL': 'http://localhost:3010/paymentStatus',
          // 'failureURL': 'http://localhost:3010/paymentStatus',
          'failureURL': environment.serviceBaseUrls.PaymentFailURL,
          'webhookURL': response.payload.webhookurl,
          'paymentModes': response.payload.paymentModes,
          'paymentSummary': [
            {
              'key': 'Premium (Ex GST)',
              'value': Math.floor(this.quoteDetail.netPremiumAmount)
            },
            {
              'key': 'GST',
              'value': Math.floor(this.quoteDetail.taxAmount)
            }],
          "trackingDetails": [
            {
              'key': 'appQuoteCriteriaId',
              'value': this.appQuoteCriteriaId
            }],
          'checkoutCustomization': {
            'instrumentCode': response.payload.paymentModes,
            'otherInstrumentAllowed': false,
            'preferredInstrumentsAllowed': false,
            'theme': localStorage.getItem('theme'),
            'campaignId': utmSource,
            "upi": upiOptions
          },
          'customSections': [{
            'subSectionId': '1B300', //1B300
            'subSectionsDetails': this.paymentSubsectionDetails()
          }],
          "productDetails": [
            {
              "productName": this.aemFragmentInfo?.productName?.variations[this.SummaryData?.quoteDetail?.productCode.toLowerCase() + '_' + this.SummaryData?.quoteItemDetail[0]?.productVariantCode.toLowerCase()]?.value,
              "productDescription": this.aemFragmentInfo?.principleName?.variations[this.SummaryData?.quoteDetail?.productCode.toLowerCase() + '_' + this.SummaryData?.quoteItemDetail[0]?.productVariantCode.toLowerCase()]?.value,
              "productImage": this.aemFragmentInfo?.logo?.variations[this.SummaryData?.quoteDetail?.productCode.toLowerCase() + '_' + this.SummaryData?.quoteItemDetail[0]?.productVariantCode.toLowerCase()]?.value,
              "backgroundColourCode": this.aemFragmentInfo?.cardColour?.variations[this.SummaryData?.quoteDetail?.productCode.toLowerCase() + '_' + this.SummaryData?.quoteItemDetail[0]?.productVariantCode.toLowerCase()]?.value,
              "fddOption": response.payload['firstdebitdtflag'] == 1 ? true : false,
              "quoteId": this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId) ? this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId) : "test_quoteId"
            }

          ]
        };
        this._paymentService.getcallbackPayment(requestPayload, response.payload.merchantCode).subscribe((res: any) => {
          console.log(res);
          const t = res.sessionKey || "",
            s = environment.paymentSecondCall + "pay/";
          this._cookieHandelerService.DeleteCookies(['payment_session_key']);
          this._cookieHandelerService.setPaymentDomainCookie('payment_session_key', res.sessionKey);
          this.showButtonLoader = false;
          this.newOtpshowLoader = false;
          this._sessionStorage.DeleteSession(['status']);
          "" !== t ? window.open(s, "_self") : alert('No session key found')
        }, (error: any) => {
          console.log(error);
          this.showButtonLoader = false;
          this.newOtpshowLoader = false;
        });
      } else {
        setTimeout(() => {
          this.showButtonLoader = false;
          this.newOtpshowLoader = false;
          this.initiateError = 'Please contact support team, something went wrong.';
        }, 5000);
      }
    },
      (error) => {
        console.log(error);
        this.showButtonLoader = false;
        this.newOtpshowLoader = false;
      });
  }
  private getSummaryDetails() {
    this.quoteItemDetail = this.SummaryData.quoteItemDetail;
    this.quoteDetail = this.SummaryData.quoteDetail;
    this.appQuoteCriteriaId = this.SummaryData.appQuoteCriteriaId;
    const data = this.SummaryData.personDetails.personDetail;
    this.proposerName = data.firstName + ' ' +
      (data.middleName ? data.middleName + ' ' : '') +
      data.lastName;
  }

  public validateOtp() {
    if (this.isOtpFormValid) {
      this.ServiceError = null;
      this.ServiceErrorCode = null;
      const outputPayload = this.createOtpPayload();
      this.newOtpshowLoader = true;
      // this.showButtonLoader = true;
      this._productReviewService.postValidateOTPForReviewDetails(outputPayload)
        .subscribe((mtResponse: any) => {
          if (mtResponse && mtResponse.nextTask && mtResponse.nextTask.nextTaskKey === CommonConstants.Routes.Application.paymentInitiate) {
            this.payHorizontal();
            if (!this.bflJourney) {
              this._adobe_analytics_service.proceedAfterPayment(mtResponse.nextTask.nextTaskKey, '');
            }
          } else if (mtResponse && mtResponse.nextTask && mtResponse.nextTask.nextTaskKey === CommonConstants.Routes.Application.InsPolicyPage) {
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTask.nextTaskKey);
            this._routerService.RouteToNextTask(mtResponse.nextTask.nextTaskKey);
          } else if (!!mtResponse.errorBean && CommonConstants.errorCodes.includes(mtResponse.errorBean[0].errorCode)) {
            this.ServiceError = mtResponse.errorBean[0].errorMessage;
            this.ServiceErrorCode = mtResponse.errorBean[0].errorCode;
            document.getElementById('digit1').focus();
          } else if (mtResponse && mtResponse.error && CommonConstants.validateOtpErrorCodes.includes(mtResponse.error[0].errorCode)) {
            this.ServiceError = mtResponse?.error[0]?.errorMessage;
            this.ServiceErrorCode = mtResponse?.error[0]?.errorCode;
            this.healthOtpForm.reset();
            document.getElementById('digit1').focus();
            if (mtResponse.error[0].errorCode === 'QDM-518') {
              this.triggerCount = 6;
            }
          } else if (mtResponse.status == 404) {
            this.ServiceError = "Please enter a valid OTP";
            this.ServiceErrorCode = mtResponse[0]?.errorCode;
            if (mtResponse[0].errorCode === 'QDM-516') {
              this.healthOtpForm.reset();
              document.getElementById('digit1').focus();
            }
            if (mtResponse[0].errorCode === 'QDM-518') {
              this.triggerCount = 6;
            }
            this.showButtonLoader = false;
            this.ShowPaymentLoader = false;
          }
          this.newOtpshowLoader = false;
          this.showButtonLoader = false;

          this.setCTCIconStyle('none');
        },
          (error: any) => {
            this.showButtonLoader = false;
            this.newOtpshowLoader = false;
            this.ServiceError = error?.error[0]?.errorMessage;
            this.ServiceErrorCode = error?.error[0]?.errorCode;
            this.setCTCIconStyle('block');
          });
    }
  }
  public getUserLocation() {
    if (sessionStorage.getItem(CommonConstants.CookieKeys.latitude)
      && sessionStorage.getItem(CommonConstants.CookieKeys.longitude)) {
      this.lat = sessionStorage.getItem(CommonConstants.CookieKeys.latitude);
      this.lng = sessionStorage.getItem(CommonConstants.CookieKeys.longitude);
      this.latlong = (this.lat).toString() + "," + (this.lng).toString();
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude ? position.coords.latitude : "";
        this.lng = position.coords.longitude ? position.coords.longitude : "";
        this.latlong = (this.lat).toString() + "," + (this.lng).toString();
      });
    }
  }
  private createOtpPayload = () => {
    this.getUserLocation();
    const outputPayload = {
      "action": "Validate",
      "payload": {
        "geoLocation": this.latlong,
        "otp": this.healthOtpForm.controls['digit1'].value + this.healthOtpForm.controls['digit2'].value +
          this.healthOtpForm.controls['digit3'].value + this.healthOtpForm.controls['digit4'].value +
          this.healthOtpForm.controls['digit5'].value + this.healthOtpForm.controls['digit6'].value,
        "consentKey": this.otpResponse && this.otpResponse.payload && this.otpResponse.payload.consentKey ?
          this.otpResponse.payload.consentKey : ""
      }

    }
    return outputPayload;
  }
  private createPayloadForGenrateOtp() {
    this.getUserLocation();
    const payload = {
      action: 'payment',
      payload: {
        "geoLocation": this.latlong
      }
    }
    return payload;
  }
  public resendOTP() {
    this.healthOtpForm.reset();
    document.getElementById('digit1').focus();
    this.generateResendOtp();
  }
  public generateResendOtp() {
    this.ServiceError = null;
    this.ServiceErrorCode = null;
    const consentKey = this.otpResponse && this.otpResponse.payload && this.otpResponse.payload.consentKey ?
      this.otpResponse.payload.consentKey : "";
    this._productReviewService.postResendSendMobileOTPForReviewDetails(this.createPayloadForGenrateOtp(), consentKey).subscribe(
      (response: any) => {
        this.triggerCount = 0;
        if (response.errorBean && CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
          this.ServiceError = response.errorBean[0].errorMessage;
          this.ServiceErrorCode = response.errorBean[0].errorCode;
        } else if (response && response[0] && response[0].errorCode === "QDM-517") {
          this.resendOTPCount = 6;
          if (this.alreadyRunningTimer) {
            clearTimeout(this.alreadyRunningTimer);
            this.remainingTime = "00:00"
          }
        } else {
          this.isTimerStarted = true;
          this.otpCountDown(60);
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  public otpCountDown(remaining) {
    var m: string | number = Math.floor(remaining / 60);
    var s: string | number = remaining % 60;

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    this.remainingTime = m + ':' + s;
    remaining -= 1;

    if (this.alreadyRunningTimer) {
      clearTimeout(this.alreadyRunningTimer);
    }

    if (remaining >= 0) {
      this.alreadyRunningTimer = setTimeout(() => {
        this.otpCountDown(remaining);
      }, 1000);
      return;
    }
    if ((m && m.toString() === '00') && (s && s.toString() === '00')) {
      this.isTimerStarted = false;
    }
  }
  public onKeydown(event, prevInput, nextInput) {
    setTimeout(() => {
      if (event.key === 'ArrowLeft' || event.key === 'Backspace') {
        prevInput.focus();
      }
      if (event.key === 'ArrowRight') {
        nextInput.focus();
      }
    }, 50);
  }

  setOTPValue(otpValue) {
    Array.from(otpValue).forEach((x, index) => {
      let counter = index + 1;
      this.healthOtpForm.controls['digit' + counter].setValue(x);
    });
  }

  onPaste(eventData, elem?: HTMLInputElement) {
    this.isOtpPasted = true;
    const clipboardData = eventData.clipboardData;
    const otpValue = clipboardData.getData('text');
    if (/\d{6}/.test(otpValue)) {
      this.setOTPValue(otpValue);
      if (elem) {
        setTimeout(() => {
          elem.value = otpValue.substr(0, 1);
          this.healthOtpForm.controls['digit1'].setValue(elem.value);
          elem.setAttribute('maxlength', '1');
        }, 10);
      }
    } else {
      eventData.preventDefault();
      return false;
    }
  }

  onOTPReceive(elem: HTMLInputElement, eventType: string, digit2?: HTMLInputElement) {
    const osType = this.analyticsService.GetDeviceDetails().os.toLowerCase();
    const isMobileFlag = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile);
    if ((osType === 'android' || osType === 'ios' || isMobileFlag === '1') && !this.isOtpPasted) {
      let digitValue;
      if (eventType === 'input' && elem.value) {
        setTimeout(() => {
          elem.setAttribute('maxlength', '6');
          digitValue = elem.value;
          elem.value = digitValue.substr(0, 1);
          this.healthOtpForm.controls['digit1'].setValue(elem.value);
          elem.setAttribute('maxlength', '1');
          if (/\d{6}/.test(digitValue)) {
            this.setOTPValue(digitValue);
          }
          if (digit2) {
            digit2.focus();
          }
          this.isOtpPasted = false;
        }, 50);
      } else if (eventType === 'click' || eventType === 'focus') {
        elem.setAttribute('maxlength', '6');
      } else if (eventType === 'blur') {
        elem.setAttribute('maxlength', '1');
      }
    }
  }

  private positionCTCIcon(bottomPosition: string) {
    setTimeout(() => {
      if (document.querySelector('#paymentOtpDrawer.open')) {
        const floatCTA = <HTMLAnchorElement>document.querySelector('a.float-help-cta');
        if (floatCTA) {
          floatCTA.style.bottom = bottomPosition;
        }
      }
    }, 200);
  }

  public onBackdropClick(eventData) {
    const floatCTA = <HTMLAnchorElement>document.querySelector('a.float-help-cta');
    if (floatCTA) {
      floatCTA.style.bottom = '70px';
    }
  }

  private setCTCIconStyle(displayProperty: string) {
    const floatCTA = <HTMLAnchorElement>document.querySelector('a.float-help-cta');
    if (floatCTA) {
      floatCTA.style.display = displayProperty;
    }
  }

  onNonStpClick() {
    let navigationUrl: string = CommonConstants.navigation[environment.name] ? CommonConstants.navigation[environment.name] : CommonConstants.navigation['uat:bfl'];
    const urlParams = new URLSearchParams(window.location.search);
    const isMobileFlag = urlParams.get('isMobile');
    this._cookieHandelerService.DeleteCookies([
      CommonConstants.CookieKeys.applicationId
    ], this._sessionStorage.GetSession(
      CommonConstants.CookieKeys.applicationId));
    this._sessionStorage.DeleteSession([
      CommonConstants.CookieKeys.applicationId,
      CommonConstants.CookieKeys.quoteId,
      CommonConstants.CookieKeys.processId,
      CommonConstants.CookieKeys.selectedQuoteId,
      CommonConstants.CookieKeys.planQuoteCriteriaData,
      CommonConstants.CookieKeys.LoanApplicationKey
    ]);
    this._cookieHandelerService.DeleteCookies([
      CommonConstants.CookieKeys.LoanApplicationId
    ]);

    if (isMobileFlag == '1') {
      // For SDK users append isMobile=1 flag to navigation url
      navigationUrl = navigationUrl + '?isMobile=1';
      window.name = '';
    } else {
      // Delete Session variables for new web journey
      this._sessionStorage.DeleteSession([
        CommonConstants.CookieKeys.JWToken,
        CommonConstants.CookieKeys.GuardToken,
        CommonConstants.CookieKeys.GuardKey,
        CommonConstants.CookieKeys.sessionId
      ]);
    }
    window.location.href = navigationUrl;
  }

  public onDateRangeCheck(): Promise<boolean> {
    let dateError;
    let dateRange = this.ClpData.dateRange;
    if (this.ClpData.existingCustomer) {
      if (!this.ClpData.isValidAgeGroup) {
        dateError = 'Invalid Date';
      }
    } else {
      let minMax = dateRange ? dateRange.split('-') : null;
      const proposerDob = this.ClpData.proposerDob;
      const dateObj = proposerDob.split('-');
      const d = parseInt(dateObj[2], 10);
      const m = parseInt(dateObj[1], 10);
      const y = dateObj[0];

      if (proposerDob) {
        const DOBObj = {
          Day: d,
          Month: m,
          Year: y
        };
        let DOB_DATE_RANGES_limit = {
          MaxAge: parseInt(minMax[1]),
          MinAge: parseInt(minMax[0])
        };
        dateError = this.FormValidators.IsDateOfBirthValid(DOBObj, null, DOB_DATE_RANGES_limit.MinAge, DOB_DATE_RANGES_limit.MaxAge);
      }
    }
    console.log("dateError : ", dateError);
    return new Promise((resolve, reject) => {
      if (dateError) {
        reject(true);
      } else {
        resolve(true);
      }
    });
  }
}
